import "./Fire.css";

function Fire() {
  return (
    <div className="content">
      <div className="light"></div>
      <div className="fire">
        <div className="back"></div>
        <div className="medium"></div>
        <div className="front"></div>
      </div>
      <div className="wood">
        <div className="stick"></div>
        <div className="stick"></div>
        <div className="stick"></div>
      </div>
    </div>
  );
}

export default Fire;
